import type { DocumentKind } from '@symphenia/shared-types'

/**
 * N-60: Die Arten in der Reihenfolge des Vorgangs — Verkauf, Rechnungen, Einkauf,
 * Sonstiges. Anlegen-Dialog und Umwandeln-Menü (N-75) gliedern gleich.
 */
export const ARTGRUPPEN: { key: string; arten: DocumentKind[] }[] = [
  { key: 'sales', arten: ['OFFER', 'ORDER_CONFIRMATION', 'DELIVERY_NOTE'] },
  { key: 'invoices', arten: ['INVOICE', 'DOWN_PAYMENT_INVOICE', 'PARTIAL_INVOICE', 'FINAL_INVOICE', 'CREDIT_NOTE', 'DUNNING'] },
  { key: 'purchase', arten: ['INQUIRY', 'PURCHASE_ORDER'] },
  { key: 'other', arten: ['CUSTOM'] },
]
